import React from 'react';

import withRouteValidation from 'hocs/withRouteValidation';

import { UserHeader } from 'components/common/Header';
import { makeStyles } from 'tss-react/mui';
import OrganizationsScreen from '../../components/screens/OrganizationsScreen';
import Footer from '../../components/home/Footer';

const useStyles = makeStyles()(() => ({
  root: {
    minHeight: `100vh`,
    flexDirection: 'column',
    display: 'flex',
    backgroundColor: 'white',
  },
  content: {
    flex: '1 0 auto',
  },
  footer: {
    flexShrink: 0,
  },
}));
const OrganizationsPage = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <UserHeader />
        <OrganizationsScreen />
      </div>
      <div className={classes.footer}>
        <Footer />
      </div>
    </div>
  );
};

export default withRouteValidation(OrganizationsPage);
